<template>
  <div :id="id" class="form-cadastro-modelo">
    <ul class="modal-tabs has-text-weight-bold">
      <li>
        <a
          id="tab-cadastro"
          :class="{
            'is-active': tabSelecionada == 'cadastro' || tabSelecionada == ''
          }"
          @click="tabSelecionada = 'cadastro'"
          ><span>Cadastro &nbsp;</span>
        </a>
      </li>
      <li v-if="checkFase">
        <a id="tab-fase" :class="{ 'is-active': tabSelecionada == 'fase' }" @click="tabSelecionada = 'fase'">
          <span>&nbsp; Fases</span>
        </a>
      </li>
    </ul>

    <form>
      <div v-show="tabSelecionada == 'cadastro' || tabSelecionada == ''">
        <TrfInput label="Nome" placeholder="Nome do modelo" id="nome-tarefa" maxLength="100" ref="inputNome" v-model="modelo.nome" :is-disabled="modeloEmEdicao.padrao" />
        <div class="container-descricao">
          <label>
            Descrição
            <span class="button is-loading is-white pl-2 pr-2 is-inline-block" style="height: 1.25em" v-if="loading.campoDescricao"></span>
          </label>
          <TrfToolbarTextEditor
            :maxlength="descricao.maxLength"
            :tipLabel="tipLabelDescricao"
            @changeText="doChangeDescricao"
            @ready="($event) => (loading.editorDeTexto = $event)"
            ref="textEditor"
          />
        </div>
        <TrfSelect
          :options="responsaveisOptions"
          label="Responsável"
          idSelect="select-responsavel-novo-modelo"
          @valueSelect="(value) => atribuirValorResponsavel(value)"
          @clear="($event) => (modelo.responsavelId = '')"
          placeholder="Selecione o responsável pelo modelo"
          ref="selectResponsavel"
          :canClear="true"
          :disabled="loadingResponsaveis || !podeEditarResponsavel"
          :loadingData="loadingResponsaveis"
          :required="false"
        />
        <div class="container-departamento">
          <TrfSelect
            label="Departamento"
            :options="listaDeDepartamentos"
            idSelect="select-departamento-nova-modelo"
            @valueSelect="(value) => atribuirValorDepartamento(value)"
            placeholder="Selecione"
            ref="selectDepartamento"
            :disabled="loadingDepartamentos || !podeEditarDepartamento"
            :loadingData="loadingDepartamentos"
          />
        </div>

        <div class="is-flex">
          <TrfCheckbox label="Gera multa por atraso" id="checkbox-gera-multa" v-model="modelo.geraMulta" class="mr-4" style="flex-shrink: 0" />
          <div class="ml-4">
            <TrfCheckbox label="Fases" id="checkbox-fase" v-model="checkFase" @update:modelValue="tratarToggleFase" />
          </div>
        </div>

        <div class="notification is-info is-light px-3 py-2" v-if="checkFase">
          A aba fases foi habilitada para que possa incluir as fases necessárias.
        </div>
      </div>
      <div v-if="checkFase" v-show="tabSelecionada == 'fase' || tabSelecionada == ''" class="pb-5">
        <TrfCadastroDeFases
          ref="cadastroDeFases"
          :isEnabled="checkFase"
          :responsaveis="listaDeResponsaveis"
          :listagemRecebida="modelo?.complementoTemplate?.fasesTemplates != null ? modelo.complementoTemplate.fasesTemplates : []"
          :tiposDeBaixa="['manual', 'personalizada']"
          :utilizaAutoComplete="false"
          :isEdicao="isEdicaoComFase"
          :listaDepartamentosFase="listaDepartamentosFase"
          :loadingCampoDepartamento="loadingDepartamentos"
          :atributosCadastro ="atributosCadastro"
          :checkboxNotificarConclusao="true"
          @update:lista-fases="($event) => definirFasesTemplates($event)"
          @error:objeto-invalido="($event) => definirErroFaseInvalida($event)"
          @error:fases-ordem-invalida="($event) => definirErroOrdemFaseInvalida($event)"
        ></TrfCadastroDeFases>
      </div>
    </form>
  </div>
</template>

<script>
import { defineAsyncComponent } from 'vue';
import { toastUtils } from '../../util/toast.utils.js';
import ModeloDeTarefaModel from '../../views/CadastroDeModelos/model/modelo-de-tarefa.js'

export default {
  name: 'TrfFormularioCadastroDeFases',
  components: {
    TrfInput: defineAsyncComponent(() => import('../Input/index.vue')),
    TrfSelect: defineAsyncComponent(() => import('../Select/index.vue')),
    TrfSelect: defineAsyncComponent(() => import('../Select/index.vue')),
    TrfToolbarTextEditor: defineAsyncComponent(() => import('.././ToolbarTextEditor/index.vue')),
    TrfCadastroDeFases: defineAsyncComponent(() => import("../CadastroDeFases/index.vue")),
    TrfCheckbox: defineAsyncComponent(() => import('../Checkbox/index.vue'))
  },
  emits: ['update:values', 'submit:error'],
  props: {
    id: {
      type: [String],
      default: 'trf-cadastro-modelo'
    },
    modeloEmEdicao: {
      type: [Object],
      default: null
    },
    listaDeResponsaveis: {
      type: [Array],
      default: new Array()
    },
    loadingResponsaveis: {
      type: [Boolean],
      default: true
    },
    listaDeDepartamentos: {
      type: [Array],
      default: new Array()
    },
    listaDepartamentosFase: {
      type: [Array],
      default: new Array()
    },
    loadingDepartamentos: {
      type: [Boolean],
      default: true
    },
  },
  data() {
    return {
      tabSelecionada: 'cadastro',
      modelo: this.modeloEmEdicao? this.modeloEmEdicao : new ModeloDeTarefaModel(),
      checkFase: false,
      isFasesValidas: false,
      isOrdemFasesValidas: false,
      loading: {
        campoDescricao: false
      },
      atributosCadastro: {
        departamentoId: null,
        responsavelId: null
      },
      descricao: {
        plainText: '',
        maxLength: 5000
      }
    }
  },
  watch: {
    modelo: {
      immediate: true,
      handler(novosDados, velhosDados) {
        this.$emit('update:values', this.modelo) 
      },
      deep: true
    },
    modeloEmEdicao: {
      immediate: true,
      handler(novosDados, velhosDados) {
        if (novosDados.id == "") return;
        this.modelo = this.modeloEmEdicao;
        this.atributosCadastro.departamentoId = this.modeloEmEdicao?.departamentoId;
        this.carregarModeloParaEdicao(this.modelo); 
      },
      deep: true
    },
    loadingDepartamentos: {
      immediate: true,
      handler(novosDados, velhosDados) {
        if (novosDados == true || novosDados == velhosDados || !this.modeloEmEdicao) return;
          if (this.modelo.departamentoId && this.modelo.departamentoId != "") {
            this.selecionarDepartamento(this.modelo.departamentoId);
          } else if (this.modelo.departamentoPadraoId && this.modelo.departamentoPadraoId != "") {
            this.selecionarDepartamento(this.modelo.departamentoPadraoId);
          }
      }
    },
    loadingResponsaveis: {
      immediate: true,
      handler(novosDados, velhosDados) {
        if (novosDados == true || novosDados == velhosDados || !this.modeloEmEdicao) return;
        this.selecionarResponsavel(this.modelo.responsavelId)
        if(Array.isArray(this.modelo?.complementoTemplate?.fasesTemplates) && this.modelo.complementoTemplate.fasesTemplates.length > 0) {
          this.checkFase = true;
        }
      }
    }
  },
  computed: {
    tipLabelDescricao() {
      let count = this.descricao.maxLength;
      if(this.modelo.descricao) {
        count -= this.descricao.plainText.length;
      }

      return `Adicione informações complementares ao modelo, caso necessário - ${count} caracteres restantes.`;
    },
    responsaveisOptions() {
      return this.listaDeResponsaveis;
    },
    isEdicaoComFase() {
      return !!this.modeloEmEdicao && !!this.modeloEmEdicao.id && this.modeloEmEdicao?.complementoTemplate?.fasesTemplates != null;
    },
    podeEditarDepartamento() {
      return this.podeEditarCampo('departamento');
    },
    
    podeEditarResponsavel() {
      return this.podeEditarCampo('responsavel');
    }
  },
  methods: {
    podeEditarCampo(campo) {
      if (!this.modeloEmEdicao?.padrao) return true;
      
      if (!this.modeloEmEdicao?.camposEditaveisPadrao) return false;
      
      try {
        const config = JSON.parse(this.modeloEmEdicao.camposEditaveisPadrao);
        return config[campo] === true;
      } catch (e) {
        return false;
      }
    },
    doChangeDescricao(value) {
      const plainText = this.$refs.textEditor.getValueAsText();
      if(plainText.length > this.descricao.maxLength) {
        return;
      }

      this.modelo.descricao = value;
      this.descricao.plainText = plainText;
    },

    atribuirValorDepartamento(value) {
      this.modelo.departamentoId = value;
      this.atributosCadastro.departamentoId = value;
    },

    atribuirValorResponsavel(value) {
      this.modelo.responsavelId = value;
    },

    async selecionarDepartamento(departamentoId) {
      await this.$nextTick();
      await this.$nextTick();
      if (departamentoId && departamentoId != "" && this.$refs.selectDepartamento) {
        this.$refs.selectDepartamento.iniciarSelectComValor(departamentoId.toString());
      }
    },
    async selecionarResponsavel(responsavelId) {
      await this.$nextTick();
      await this.$nextTick();
      if (responsavelId && responsavelId != "" && this.$refs.selectResponsavel) {
        this.$refs.selectResponsavel.iniciarSelectComValor(responsavelId);
      }
    },
    carregarModeloParaEdicao(modelo) {
      this.modelo.descricao = this.$refs.textEditor.iniciarTextEditorComValor(
        modelo.descricao
      );
      if (!this.loadingDepartamentos) {
        this.selecionarDepartamento(modelo.departamentoId != "" ? modelo.departamentoId : modelo.departamentoPadraoId);
      };
      if (!this.loadingResponsaveis) {
        this.selecionarResponsavel(this.modelo.responsavelId);
      };
      if (!this.loadingResponsaveis && Array.isArray(modelo?.complementoTemplate?.fasesTemplates) && modelo.complementoTemplate.fasesTemplates.length > 0) {
        this.checkFase = true;
      }
    },
    isFasesAtivas() {
      return this.checkFase;
    },
    definirErroFaseInvalida(resultado) {
      this.isFasesValidas = !resultado
    },
    definirErroOrdemFaseInvalida(resultado) {
      this.isOrdemFasesValidas = !resultado
    },
    definirFasesTemplates(valor) {
      this.modelo.complementoTemplate.fasesTemplates = valor;
    },
    tratarToggleFase() {
      if (this.modelo.complementoTemplate == null) {
        this.modelo.complementoTemplate = {};
      }
      if (this.checkFase) {
        this.modelo.complementoTemplate.fasesTemplates = this.isEdicaoComFase
          ? [...this.modeloEmEdicao?.complementoTemplate?.fasesTemplates]
          : [];
      } else {
        this.$refs.cadastroDeFases.limparCamposFase();
        this.$refs.cadastroDeFases.limparListagemFases();
        this.modelo.complementoTemplate.fasesTemplates = null;
      }
    },
    checkValidity(mostrarErrorToast) {
      const isNomeValido = !this.$refs.inputNome.verificarSeInputEstaVazio();
      const isDepartamentoValido = !this.$refs.selectDepartamento.verificarSeInputEstaVazio();

      let isFasesValidas = !this.checkFase;
      let isFasesArrayValida = !this.checkFase;
      if (this.checkFase) {
        isFasesArrayValida = Array.isArray(this.modelo.complementoTemplate.fasesTemplates) && this.modelo.complementoTemplate.fasesTemplates.length > 0;
        isFasesValidas = this.isOrdemFasesValidas && isFasesArrayValida;
      }

      if (mostrarErrorToast) {
        this.exibirErros(isNomeValido, isDepartamentoValido, isFasesValidas, isFasesArrayValida);
      }

      return isNomeValido && isDepartamentoValido && isFasesValidas;
    },
    exibirErros(validacaoNome, validacaoDepartamento, validacaoOrdemFase, validacaoFases) {
      if (!validacaoNome) {
        toastUtils.dangerToast('Nome do modelo inválido. Verifique.');
      } else if (!validacaoDepartamento) {
        toastUtils.dangerToast('Departamento do modelo inválido. Verifique.');
      } else if (!validacaoFases) {
        toastUtils.dangerToast('Adicione fases em seu modelo.');
      } else if (!validacaoOrdemFase) {
        toastUtils.dangerToast('As fases devem ser cadastradas em sequência numérica. Verifique.');
      }
    },
    limparFormulario() {
      this.modelo = new ModeloDeTarefaModel();
      this.$refs.selectDepartamento.limparSelect();
      this.$refs.selectResponsavel.limparSelect();
      this.$refs.selectDepartamento.limparValidacao();
      this.$refs.selectResponsavel.limparValidacao();
      this.$refs.inputNome.limparValidacao();
      this.$refs.textEditor.limparCampo();
      if(this.checkFase) {
        this.$refs.cadastroDeFases.limparCamposFase();
        this.modelo.complementoTemplate.fasesTemplates = null;
        this.checkFase = false;
      }
      this.tabSelecionada = 'cadastro';
    }
  }
};
</script>
<style lang="scss" scoped>
#btn-adicionar {
  margin-right: 5px;
}
.content-fase {
  overflow: hidden;
  max-height: 0;
  opacity: 0;
  transition: max-height 0.35s ease-in 0s, opacity 0.25s ease-in 0.1s;
  &.is-open {
    max-height: 1000vh;
    transition: max-height 0.35s ease-out 0s, opacity 0.25s ease-out 0.1s;
    opacity: 1;
    overflow: visible;
  }
}
.columns.is-form {
  .column {
    padding-bottom: 0 !important;
  }
}
.tip-label-grupo {
  font-style: italic;
  font-size: 12px;
}
</style>
